/* Native scroll carousels. No auto-rotation, cloned reviews or third-party library. */
(() => {
  if (window.vapRefreshLoaded) return;
  window.vapRefreshLoaded = true;
  const cleanups = new WeakMap();
  const categoryCleanups = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('.ve-category-track').forEach(track => {
      if (categoryCleanups.has(track)) return;
      const cards = [...track.querySelectorAll('[data-ve-category-card]')];
      if (!cards.length || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach(card => card.classList.add('is-active'));
        categoryCleanups.set(track, () => {});
        return;
      }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-active', entry.intersectionRatio >= .62)), {root: track, threshold: [.35, .62, .9]});
      cards.forEach(card => observer.observe(card));
      requestAnimationFrame(() => track.classList.add('ve-motion-ready'));
      categoryCleanups.set(track, () => observer.disconnect());
    });
    root.querySelectorAll('[data-ve-carousel]').forEach(section => {
      if (cleanups.has(section)) return;
      const track = section.querySelector('[data-ve-track]');
      const previous = section.querySelector('[data-ve-prev]');
      const next = section.querySelector('[data-ve-next]');
      const dots = section.querySelector('[data-ve-dots]');
      if (!track || !previous || !next) return;
      const drawDots = () => {
        if (!dots) return;
        const pageCount = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
        const active = Math.min(pageCount - 1, Math.round(track.scrollLeft / track.clientWidth));
        if (dots.children.length !== pageCount) {
          dots.replaceChildren();
          for (let index = 0; index < pageCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'dark-carousel-dot';
            dot.setAttribute('aria-label', `Ir a la página ${index + 1} de marcas`);
            dot.addEventListener('click', () => track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
            dots.appendChild(dot);
          }
        }
        [...dots.children].forEach((dot, index) => {
          dot.classList.toggle('active', index === active);
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
        drawDots();
      };
      const move = direction => {
        track.scrollBy({left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const prevClick = () => move(-1), nextClick = () => move(1);
      previous.addEventListener('click', prevClick);
      next.addEventListener('click', nextClick);
      track.addEventListener('scroll', update, {passive: true});
      const resize = new ResizeObserver(update);
      resize.observe(track);
      cleanups.set(section, () => {resize.disconnect();previous.removeEventListener('click', prevClick);next.removeEventListener('click', nextClick);track.removeEventListener('scroll', update);});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-ve-carousel]').forEach(section => {cleanups.get(section)?.();cleanups.delete(section);});
    e.target.querySelectorAll('.ve-category-track').forEach(track => {categoryCleanups.get(track)?.();categoryCleanups.delete(track);});
  });
})();
